import { isNativeApp } from './isNativeApp';

const DEFAULT_NATIVE_BACKEND_URL = 'https://sostegnopro.it';
const DEFAULT_FUNCTIONS_BACKEND_URL = 'https://europe-west1-sostegno-pro.cloudfunctions.net/sostegno_backend_api';

function stripTrailingSlash(url) {
  if (!url || typeof url !== 'string') return url;
  return url.endsWith('/') ? url.slice(0, -1) : url;
}

function getForcedBackendFromUrl() {
  try {
    if (typeof window === 'undefined') return '';
    const params = new URLSearchParams(window.location.search || '');
    const explicit = stripTrailingSlash(params.get('backendUrl') || '');
    if (explicit) return explicit;

    const mode = String(params.get('backend') || '').trim().toLowerCase();
    if (mode === 'functions' || mode === 'cloudfunctions' || mode === 'cf') {
      return DEFAULT_FUNCTIONS_BACKEND_URL;
    }
  } catch {
    // ignore
  }
  return '';
}

export function getBackendBaseUrl() {
  const forced = getForcedBackendFromUrl();
  if (forced) return forced;

  const fromEnv = stripTrailingSlash(process.env.REACT_APP_BACKEND_URL);
  if (fromEnv) {
    // In app nativa l'override esplicito è spesso necessario.
    if (isNativeApp()) return fromEnv;

    // In sviluppo locale (CRA), usare l'override è utile per puntare al backend remoto.
    const origin = stripTrailingSlash(window.location.origin);
    const isLocalhost = origin.includes('localhost') || origin.includes('127.0.0.1');
    if (isLocalhost) return fromEnv;

    // In web preferiamo usare i rewrite di Firebase Hosting (origin + /api).
    // Evitiamo override “sbagliati” (es. dominio marketing) che causano 404 su /api/*.
    const looksLikeBackendHost =
      fromEnv === origin ||
      fromEnv.includes('localhost') ||
      fromEnv.includes('127.0.0.1') ||
      fromEnv.includes('cloudfunctions.net') ||
      fromEnv.endsWith('.run.app');

    if (looksLikeBackendHost) return fromEnv;
  }

  if (isNativeApp()) {
    return DEFAULT_NATIVE_BACKEND_URL;
  }

  return window.location.origin;
}

export function getApiBaseUrl() {
  return `${getBackendBaseUrl()}/api`;
}

export async function maybeLogApiDebug() {
  try {
    if (typeof window === 'undefined') return;
    const params = new URLSearchParams(window.location.search);
    if (!params.has('debugApi')) return;

    const backendBaseUrl = getBackendBaseUrl();
    const apiBaseUrl = getApiBaseUrl();

    // eslint-disable-next-line no-console
    console.log('[debugApi] origin:', window.location.origin);
    // eslint-disable-next-line no-console
    console.log('[debugApi] backendBaseUrl:', backendBaseUrl);
    // eslint-disable-next-line no-console
    console.log('[debugApi] apiBaseUrl:', apiBaseUrl);

    try {
      const r = await fetch(`${apiBaseUrl}/health`, {
        method: 'GET',
        credentials: 'include'
      });
      const txt = await r.text();
      // eslint-disable-next-line no-console
      console.log('[debugApi] GET /api/health status:', r.status, 'body:', txt);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('[debugApi] GET /api/health failed:', e);
    }
  } catch {
    // ignore
  }
}
